<template>
  
  <div class="canvas">
    <div>
      <div class="biaoti">管理员</div>
      <div style="float: right;">
        <el-button type="primary" @click="showAddAdminDialog">新增</el-button>
      </div>
      <el-table :data="adminList" style="width: 100%">
        <el-table-column prop="id" label="编号" width="180"></el-table-column>
        <el-table-column prop="userid" label="管理员id" width="180"></el-table-column>
        <el-table-column prop="createdAt" label="创建时间" width="180"></el-table-column>
        <el-table-column label="操作" width="180">
          <template #default="scope">
            <el-button type="text" @click="deleteAdmin(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
  
      <!-- 新增管理员对话框 -->
      <el-dialog title="新增管理员" :visible.sync="addAdminDialogVisible" width="30%">
        <el-form ref="addForm" :model="addForm" label-width="80px" @submit.native.prevent="addAdmin">
          <el-form-item label="管理员" required>
            <el-input v-model="addForm.username" placeholder="请输入管理员名称"></el-input>
          </el-form-item>
          <el-form-item label="手机号" required>
            <el-input v-model="addForm.phone" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addAdmin">确定</el-button>
            <el-button @click="addAdminDialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>
  <script>
  export default {
    data() {
      return {
        adminList: [],
        addAdminDialogVisible: false,
        addForm: {
          username: '',
          phone: ''
        }
      };
    },
    mounted() {
      this.fetchAdminList();
    },
    methods: {
      fetchAdminList() {
        this.$axios.get("/api/all_admin")
          .then(response => {
            this.adminList = response.data.data;
          });
      },
      showAddAdminDialog() {
        this.addAdminDialogVisible = true;
        this.addForm = { username: '', phone: '' };
      },
      addAdmin() {
        if (!this.addForm.username || !this.addForm.phone) {
          alert("管理员名称和手机号不能为空");
          return;
        }
        if (!this.validatePhone(this.addForm.phone)) {
          alert("手机号格式不正确");
          return;
        }
        this.$axios.post("/api/add_admin", this.addForm)
          .then(response => {
            if (response.data.data == 1) {
              alert("添加成功");
              this.addAdminDialogVisible = false; // 关闭对话框
              this.fetchAdminList(); // 动态刷新管理员列表
            } else if (response.data.data == 2) {
              alert("这个人已经是管理员了");
            } else {
              alert("手机号填写错误，请判断这个手机号是否在企业微信内");
            }
          });
      },
      validatePhone(phone) {
        const phoneRegex = /^1[3-9]\d{9}$/; // 简单的手机号正则表达式
        return phoneRegex.test(phone);
      },
      deleteAdmin(id) {
        this.adminList = this.adminList.filter(item => item.id !== id);
      }
    }
  };
  </script>
  
  <style>
  .dialog-footer {
    text-align: right;
  }
  .canvas {
    background-color: white; /* 设置画布为白色 */
    padding: 20px;
    border-radius: 10px; /* 可以根据需要调整画布的圆角 */
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2); /* 给画布添加阴影效果 */
    width: 98%; /* 根据需要调整画布宽度 */
    position: relative;
  }
  .biaoti {
    font-family: 'Georgia', serif;
    color: #4396e5;
    font-size: 30px;
    font-weight: bold;
    padding: 15px;
  }
  </style>